import React from "react";
import PropTypes from "prop-types";

import { useBooleanState, useSnoozeOptions } from "../../hooks";
import { Button, Icon, PopupMenu } from "..";

function SnoozeOptions({ expirationDate, onSnooze }) {
  const [isOpen, open, close] = useBooleanState();
  const options = useSnoozeOptions(expirationDate);

  if (!options.length)
    return (
      <Icon
        data-test="snooze-icon"
        name="close"
        link
        onClick={() => {
          close();
          onSnooze();
        }}
      />
    );

  return (
    <PopupMenu
      open={isOpen}
      onOpen={open}
      showIcon={false}
      onClose={close}
      data-test="snooze-options-popup"
      trigger={<Icon data-test="snooze-icon" link name="close" />}
    >
      <React.Fragment>
        {options.map((args) => {
          return (
            <Button
              key={args.days}
              onClick={() => {
                close();
                onSnooze(args);
              }}
              content={args.text}
            />
          );
        })}
      </React.Fragment>
    </PopupMenu>
  );
}

SnoozeOptions.propTypes = {
  expirationDate: PropTypes.instanceOf(Date),
  onSnooze: PropTypes.func.isRequired,
};

SnoozeOptions.defaultProps = { expirationDate: undefined };

export default SnoozeOptions;
